import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import HelpTooltip from '../ui/Tooltip';

function generateStops(range) {
  return range.map((d, i) => <stop key={i} />);
}

const D3Legend = ({
  width,
  height,
  colorScale,
  range,
  title,
  url,
  tooltipText,
}) => {
  const ref = useRef(null);
  const translateX = 8;

  useEffect(() => {
    const group = d3.select(ref.current);
    const xScale = d3.scaleLinear(
      [range[0], range[range.length - 1]],
      [0, width],
    );
    const xAxis = d3
      .axisBottom()
      .scale(xScale)
      .tickValues(range)
      .tickSize(0);

    const urlTitle = title?.replace(/ /g, '');
    group
      .selectAll('linearGradient')
      .attr('id', `d3legend${urlTitle}`)
      .attr('x1', '0%')
      .attr('y1', '0%')
      .attr('x2', '100%')
      .attr('y2', '0%');

    group
      .selectAll('stop')
      .attr('offset', (d, i) => `${(i * 100) / (range.length - 1)}%`)
      .attr('stop-color', (d, i) => colorScale(range[i]))
      .attr('stop-opacity', 1);

    group
      .selectAll('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('stroke', 'black')
      .attr('stroke-width', 0.5)
      .attr('width', width)
      .attr('height', height)
      .attr('transform', `translate(${translateX}, 1)`)
      .style('fill', `url(#d3legend${urlTitle})`);

    group
      .selectAll('g.legendAxis')
      .attr('transform', `translate(${translateX}, ${height})`)
      .call(xAxis)
      .select('.domain')
      .remove();
  }, [width, height, colorScale, range]);

  return (
    <div style={{ float: 'right', textAlign: 'center' }}>
      {title && (
        <div>
          {title}
          {url && tooltipText && <HelpTooltip text={tooltipText} url={url} />}
        </div>
      )}
      <svg width={width + translateX + 10} height={height + 11}>
        <g ref={ref}>
          <defs>
            <linearGradient>{generateStops(range)}</linearGradient>
          </defs>
          <rect />
          <g className="legendAxis" />
        </g>
      </svg>
    </div>
  );
};

D3Legend.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  colorScale: PropTypes.func.isRequired,
  range: PropTypes.arrayOf(PropTypes.number).isRequired,
  title: PropTypes.string,
  url: PropTypes.string,
  tooltipText: PropTypes.string,
};

D3Legend.defaultProps = {
  title: null,
  url: null,
  tooltipText: null,
};

export default D3Legend;
